import { TypedUseSelectorHook, useSelector } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";
import { rootReducer } from ".";
import thunk from "redux-thunk";

// Store
const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(thunk),
  devTools: process.env.NODE_ENV !== "production",
});

// Types
export type StoreType = ReturnType<typeof rootReducer>;

// Typed selector
const useAppSelector: TypedUseSelectorHook<StoreType> = useSelector;

export { store, useAppSelector };
